module.exports = __webpack_public_path__ + "img/Klarna_Payment_Badge.bfcf23ac.svg";